import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components/macro'

/** A normal reply lands in a few seconds; past this, say we're still on it. */
export const OLLIE_STILL_WORKING_AFTER_MS = 10 * 1000
export const OLLIE_STILL_WORKING_COPY = 'Still working…'

const OllieTypingIndicator = ({
  stillWorkingAfterMs = OLLIE_STILL_WORKING_AFTER_MS,
}) => {
  const [stillWorking, setStillWorking] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setStillWorking(true), stillWorkingAfterMs)
    return () => clearTimeout(timer)
  }, [stillWorkingAfterMs])

  return (
    <Row
      aria-label={stillWorking ? OLLIE_STILL_WORKING_COPY : 'Ollie is typing'}
      data-testid='ollie-typing'
    >
      <Bubble>
        <Dot $delay={0} />
        <Dot $delay={0.15} />
        <Dot $delay={0.3} />
        {stillWorking && (
          <StillWorking data-testid='ollie-still-working' aria-live='polite'>
            {OLLIE_STILL_WORKING_COPY}
          </StillWorking>
        )}
      </Bubble>
    </Row>
  )
}

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 14px;
`

const Bubble = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 14px 16px;
  border-radius: 14px 14px 14px 4px;
  background: ${({ theme }) => theme.colours.mayoWhite};
  border: 1px solid ${({ theme }) => theme.colours.panSilver};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colours.oliveGrey};
  animation: ${bounce} 1s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`

const StillWorking = styled.span`
  margin-left: 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

export default OllieTypingIndicator
